export const MULTI_SELECT_TABLE_VIEW_VALUE_TAG_CLASS = 'multi-select-table-view-value-tag';
